import { baseApi, getProvidesIDTags } from "./baseApi";

const BASE_URL = "users";

export const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: (data) => ({ url: BASE_URL, method: "get", data }),
      providesTags: (result) => getProvidesIDTags(result ? result.results : [], "User"),
    }),
    getAllUsers: builder.query({
      query: (data) => ({ url: `${BASE_URL}/all`, method: "get", data }),
      providesTags: (result) => getProvidesIDTags(result ? result.results : [], "User"),
    }),
    updateAccount: builder.mutation({
      query: (data) => ({ url: `${BASE_URL}/me`, method: "put", data }),
      invalidatesTags: (result, error, arg) => [{ type: "User", id: arg.id }],
    }),
    editUser: builder.mutation({
      query: (data) => ({ url: `${BASE_URL}/${data.id}`, method: "put", data }),
      invalidatesTags: ["User"],
    }),
    // use put request to include data
    deleteUser: builder.mutation({
      query: ({ id, ...data }) => ({ url: `${BASE_URL}/${id}/delete`, method: "put", data }),
      invalidatesTags: (result, error, arg) => [{ type: "User", id: arg.id }],
    }),
    setPriceRequestAdmin: builder.mutation({
      query: ({ id }) => ({ url: `${BASE_URL}/${id}/price-request-admin`, method: "put" }),
      invalidatesTags: (result, error, arg) => [{ type: "User", id: arg.id }],
    }),
    googleLogin: builder.mutation({
      query: (data) => ({ url: "google/login", method: "post", data })
    }),
  }),
  overrideExisting: true
});

// auto-generated based on the defined endpoints
export const {
  useGetUsersQuery,
  useGetAllUsersQuery,
  useUpdateAccountMutation,
  useEditUserMutation,
  useDeleteUserMutation,
  useSetPriceRequestAdminMutation,
  useGoogleLoginMutation,
} = userApi;
